import * as React from 'react';

import type {DueDateUnit as DelayUnit} from 'nutshell-core/types';

import type {TimespanInput} from 'nutshell-graphql-types';

import {EmptyAddCard} from '../card/empty-add-card';
import type {DripEditionStatus} from '../edition/get-edition-status-info';
import {LoadingPage} from '../loading-page/loading-page';

import {MapThumbnailCard} from './map-thumbnail-card';

import styles from './mini-map.module.css';

type Props = {
    editions: {
        id: string;
        name: string;
        emailTemplate?: {
            thumbnailUrl: string | null | undefined;
        };
        delay:
            | {
                  unit: DelayUnit;
                  timespan: number;
              }
            | null
            | undefined;
        status?: DripEditionStatus;
        backgroundColor: string;
        previewComponent?: React.ReactNode;
    }[];
    selectedId: string;
    onSelectMessage: (editionId: string) => void;
    onAddMessage?: () => void;
    isLoading: boolean;
    onUpdateEdition: (arg1: {editionId: string; delay: TimespanInput}) => Promise<any>;
};

export function MiniMap(props: Props) {
    const {onAddMessage} = props;

    return (
        <div>
            {props.isLoading ? (
                <LoadingPage padding={0} />
            ) : (
                <>
                    {props.editions.map((edition, index) => (
                        <MapThumbnailCard
                            key={edition.id}
                            id={edition.id}
                            name={edition.name}
                            delay={index === 0 ? undefined : edition.delay}
                            thumbnailUrl={
                                edition.emailTemplate && edition.emailTemplate.thumbnailUrl
                                    ? edition.emailTemplate.thumbnailUrl
                                    : undefined
                            }
                            status={edition.status}
                            isSelected={props.selectedId === edition.id}
                            onSelectMessage={props.onSelectMessage}
                            onUpdateEdition={props.onUpdateEdition}
                            backgroundColor={edition.backgroundColor}
                            previewComponent={edition.previewComponent}
                        />
                    ))}
                    {onAddMessage ? (
                        <div className={styles['add-message-container']}>
                            <EmptyAddCard
                                text='Add a message'
                                background='off-white'
                                size='small'
                                onClick={onAddMessage}
                            />
                        </div>
                    ) : null}
                </>
            )}
        </div>
    );
}
